module.exports = __webpack_public_path__ + "static/media/board-2x.7410268d.png";